import TheTeamList from '@/components/TheTeam/TheTeamList'
import TheTeamForm from '@/components/TheTeam/TheTeamForm'

let TheTeamRouter = [{
  path: '/theteam',
  name: 'TheTeamList',
  component: TheTeamList,
  meta: {
    title: "L'équipe",
    requiresAuth: true,
    authorizations: ['theteam_index', 'desktop_access']
  }
}, {
  path: '/theteam/new',
  name: 'TheTeamNew',
  component: TheTeamForm,
  meta: {
    title: "Nouveau membre de l'équipe",
    requiresAuth: true,
    authorizations: ['theteam_new', 'desktop_access']
  }
}, {
  path: '/theteam/:id/edit',
  name: 'TheTeamEdit',
  component: TheTeamForm,
  meta: {
    title: "Modifier un membre de l'équipe",
    requiresAuth: true,
    authorizations: ['theteam_edit', 'desktop_access']
  }
}]

export default TheTeamRouter



// WEBPACK FOOTER //
// ./src/components/TheTeam/router.js